import React from 'react';
import { BulkActionBar, BulkActionButton } from '../../../components/bulk-action-bar';
import { ACTING_AS_REQUIRED_HINT } from '../../../utils/bulkSelection';

type ContactsBulkBarProps = {
  count: number;
  busy: boolean;
  canLink: boolean;
  canUnlink: boolean;
  canDelete: boolean;
  /** Linking creates org-bound rows, so it needs an acting-as org. */
  isActingAs: boolean;
  onAdd: () => void;
  onRemove: () => void;
  onDelete: () => void;
  onClear: () => void;
};

/** The contacts list's bulk actions, each gated on its own permission. */
export const ContactsBulkBar: React.FC<ContactsBulkBarProps> = ({
  count,
  busy,
  canLink,
  canUnlink,
  canDelete,
  isActingAs,
  onAdd,
  onRemove,
  onDelete,
  onClear,
}) => (
  <BulkActionBar count={count} busy={busy} onClear={onClear} data-testid="contacts-bulk-bar">
    {canLink && (
      <BulkActionButton
        onClick={onAdd}
        disabled={busy || !isActingAs}
        title={isActingAs ? undefined : ACTING_AS_REQUIRED_HINT}
        data-testid="contacts-bulk-add"
      >
        Add to facilities
      </BulkActionButton>
    )}
    {canUnlink && (
      <BulkActionButton onClick={onRemove} disabled={busy} data-testid="contacts-bulk-remove">
        Remove from facilities
      </BulkActionButton>
    )}
    {canDelete && (
      <BulkActionButton onClick={onDelete} disabled={busy} data-testid="contacts-bulk-delete">
        Delete
      </BulkActionButton>
    )}
  </BulkActionBar>
);
